"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _layout = require("../layout");

var _utils = require("../utils");

var _core = require("@emotion/core");

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FormWrapper = function FormWrapper(_ref) {
  var children = _ref.children,
      outerProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilFormWrapper'
  });
  return (0, _core.jsx)(_context.StencilConsumer, null, function (context) {
    return (0, _core.jsx)(_layout.Col, (0, _extends2.default)({
      gridGap: (0, _utils.getThemeSpace)(context, 'S400')
    }, dataTestProps, outerProps), children);
  });
};

var FormWrapperWithDocs = (0, _stencilReactDesc.describe)(FormWrapper).description('Sets vertical spacing between form elements.');
FormWrapperWithDocs.propTypes = _objectSpread({}, (0, _utils.omit)(_layout.Col.describedPropTypes, ['gridGap']));
FormWrapperWithDocs.displayName = 'FormWrapper';
var _default = FormWrapperWithDocs;
exports.default = _default;